'use client'; // global-error replaces the root layout, so it must be a Client Component

// Renders only when the root layout itself throws. Because it bypasses the
// root layout, neither global styles nor fonts are available here — styles are
// inlined to keep the fallback self-contained.
export default function GlobalError({ error, unstable_retry }) {
  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '20px',
          background: '#fbfaf6',
          color: '#1d1d1d',
          fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
          textAlign: 'center',
          padding: '24px',
        }}
      >
        <p
          style={{
            fontSize: '11px',
            fontWeight: 600,
            letterSpacing: '0.22em',
            textTransform: 'uppercase',
            color: '#9a7a1f',
            margin: 0,
          }}
        >
          Something went wrong
        </p>
        <h1 style={{ fontSize: '40px', lineHeight: 1.1, margin: 0, fontWeight: 500 }}>
          A frame came back blurred.
        </h1>
        <p style={{ color: '#5a5a58', maxWidth: '440px', margin: 0, lineHeight: 1.7 }}>
          An unexpected error interrupted the page. Your data is untouched — try
          again, or reload.
        </p>
        <button
          onClick={() => unstable_retry()}
          style={{
            marginTop: '8px',
            padding: '14px 32px',
            background: '#1d1d1d',
            color: '#fff',
            border: 'none',
            fontSize: '11px',
            fontWeight: 600,
            letterSpacing: '0.22em',
            textTransform: 'uppercase',
            cursor: 'pointer',
          }}
        >
          Try again
        </button>
      </body>
    </html>
  );
}
